import React, { Fragment } from "react";
import { Box, Container, Typography, Divider, Paper } from "@mui/material";
import SEO from "../../components/ceo/CEO";

const Terms = () => {
  return (
    <Fragment>
      <SEO
        title="Terms of Use"
        description="Read the terms of use for SHALL Social and Development Organization. Understand the rules and guidelines for using our website and services."
        url="https://shallafg.org/terms/"
      />
      <Box
        sx={{
          backgroundColor: "#0B0F19",
          color: "#FFFFFF",
          paddingY: { xs: "40px", md: "80px" },
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="md">
          <Paper
            sx={{
              padding: { xs: "20px", md: "50px" },
              backgroundColor: "#1A2E55",
              borderRadius: "16px",
              boxShadow: "0 8px 40px rgba(0, 0, 0, 0.5)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
            }}
          >
            {/* Terms of Use Header */}
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: "#E3F2FD",
                textAlign: "center",
                marginBottom: "40px",
                fontSize: { xs: "2rem", md: "3rem" },
                letterSpacing: "1px",
              }}
            >
              Terms of Use
            </Typography>

            {/* Terms Section */}
            {termsSections.map((section, index) => (
              <Box key={index} sx={{ marginBottom: "40px" }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: "#A9C9EA",
                    fontSize: { xs: "1.4rem", md: "1.6rem" },
                    marginBottom: "10px",
                    letterSpacing: "0.5px",
                  }}
                >
                  {section.title}
                </Typography>
                <Divider
                  sx={{
                    backgroundColor: "#007BFF",
                    marginBottom: "20px",
                    height: "2px",
                    width: "100px",
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: "1.8",
                    color: "#D1D5DB",
                  }}
                >
                  {section.content}
                </Typography>
              </Box>
            ))}

            {/* Footer Note */}
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                color: "#90CAF9",
                marginTop: "40px",
                fontStyle: "italic",
              }}
            >
              By using our website, you agree to these Terms of Use.
            </Typography>
          </Paper>
        </Container>
      </Box>
    </Fragment>
  );
};

// Sample sections for Terms of Use
const termsSections = [
  {
    title: "1. Using Our Website",
    content:
      "You can use our website to learn about our activities, donate, and access our services. Please use the site responsibly and follow all laws.",
  },
  {
    title: "2. Content Ownership",
    content:
      "All content on our website, including text, images, and videos, belongs to SHALL SDO. You may not copy, sell, or use our content without permission.",
  },
  {
    title: "3. Donations",
    content:
      "When you donate through our website, you agree that your donation is voluntary. We will provide updates on how your donation is used.",
  },
  {
    title: "4. No Misuse",
    content:
      "You agree not to misuse our website. This includes not hacking, spamming, or trying to harm the website or other users.",
  },
  {
    title: "5. Privacy",
    content:
      "We respect your privacy. Our Privacy Policy explains how we collect and use your personal data. By using the website, you also agree to our Privacy Policy.",
  },
  {
    title: "6. Third-Party Links",
    content:
      "Our website may link to other websites. We are not responsible for the content, privacy, or security of these third-party websites.",
  },
  {
    title: "7. Changes to the Website",
    content:
      "We may update or change the content on our website at any time without notice.",
  },
  {
    title: "8. Termination of Use",
    content:
      "We can stop your access to our website at any time if you do not follow these Terms of Use.",
  },
  {
    title: "9. Changes to These Terms",
    content:
      "We may change these terms. Please check this page regularly. By continuing to use the website, you agree to any updates.",
  },
  {
    title: "10. Contact Us",
    content:
      "If you have any questions about these Terms of Use, you can contact us by email or phone.",
  },
];

export default Terms;
